import { render, staticRenderFns } from "./AreasGroups.vue?vue&type=template&id=343db7e6&"
import script from "./AreasGroups.vue?vue&type=script&lang=js&"
export * from "./AreasGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports